import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useIsAskMeAnythingEnabled, useIsCommunityAskMeAnythingEnabled } from '@ms/yammer-hooks/dist/askMeAnything';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useShouldShowNewEventsLayout } from '@ms/yammer-hooks/dist/routes';
import PageLayout from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { eventPageMatchPath } from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import Page from '../Page';

import { ContentRoutes } from './ContentRoutes';
import {
  Article,
  ArticleNew,
  AskMeAnything,
  AskMeAnythingCommunityEvents,
  AskMeAnythingEventCreation,
  AskMeAnythingLeadersEvents,
  AskMeAnythingUserEvents,
  GroupInsights,
  LiveEvent,
  Logout,
  UserInsights,
} from './loadableComponents';

const Routes: FC = () => {
  const shouldShowNewEventsLayout = useShouldShowNewEventsLayout();
  const isAskMeAnythingEnabled = useIsAskMeAnythingEnabled();
  const isCommunityAskMeAnythingEnabled = useIsCommunityAskMeAnythingEnabled();
  const userInsightsExperimentEnabled = useExperimentTreatmentWithoutReporting(Experiment.UserInsights) === true;

  const askMeAnythingPage = isAskMeAnythingEnabled ? (
    <Route path="/ama/:teamsMeetingId">
      <Page>
        <AskMeAnything />
      </Page>
    </Route>
  ) : null;
  const askMeAnythingCommunityEventsPage = isCommunityAskMeAnythingEnabled ? (
    <Route path="/groups/:groupId/events/askmeanything">
      <Page>
        <AskMeAnythingCommunityEvents />
      </Page>
    </Route>
  ) : null;
  const askMeAnythingUserEventsPage = isAskMeAnythingEnabled ? (
    <Route exact={true} path="/users/:userId/events/askmeanything">
      <Page>
        <AskMeAnythingUserEvents />
      </Page>
    </Route>
  ) : null;
  const askMeAnythingLeadersEventsPage = isAskMeAnythingEnabled ? (
    <Route exact={true} path="/leadership-corner/events/askmeanything">
      <Page>
        <AskMeAnythingLeadersEvents />
      </Page>
    </Route>
  ) : null;
  const userInsightsPage = userInsightsExperimentEnabled ? (
    <Route path="/users/:userId/insights">
      <Page>
        <UserInsights />
      </Page>
    </Route>
  ) : null;

  return (
    <Switch>
      <Route path={eventPageMatchPath}>
        <Page
          collapseLeftSidebar={shouldShowNewEventsLayout}
          noScroll={shouldShowNewEventsLayout}
          noSpacing={shouldShowNewEventsLayout}
        >
          <LiveEvent />
        </Page>
      </Route>
      <Route exact={true} path="/articles/new">
        <Page isLeftSidebarEnabled={false}>
          <ArticleNew />
        </Page>
      </Route>
      <Route exact={true} path="/articles/:threadId">
        <Article />
      </Route>
      <Route exact={true} path="/ama/new/:userId?">
        <Page>
          <AskMeAnythingEventCreation />
        </Page>
      </Route>
      {askMeAnythingPage}
      {askMeAnythingCommunityEventsPage}
      {askMeAnythingUserEventsPage}
      {askMeAnythingLeadersEventsPage}
      <Route path="/groups/:groupId/activity">
        <Page>
          <GroupInsights />
        </Page>
      </Route>
      {userInsightsPage}
      <Route path="/logout">
        <PageLayout>
          <Logout />
        </PageLayout>
      </Route>
      <Route default={true}>
        <Page>
          <ContentRoutes />
        </Page>
      </Route>
    </Switch>
  );
};

export default Routes;
